import styled, { css, DefaultTheme } from 'styled-components';
import { TTagVariant, TTagSize } from './tag.types';

const prefixCls = 'ui-tag';

export const tagClasses = {
  component: prefixCls,
  icon: `${prefixCls}-icon`,
  label: `${prefixCls}-label`,
} as const;

export const ICON_SIZE_MAP: Record<TTagSize, { width: number; height: number }> = {
  small: {
    width: 16,
    height: 16,
  },
  medium: {
    width: 20,
    height: 20,
  },
  large: {
    width: 24,
    height: 24,
  },
};

export const TAG_SIZE_MAP: Record<TTagSize, number> = {
  small: 16,
  medium: 20,
  large: 24,
};

export function getTagColor(theme: DefaultTheme, variant: TTagVariant) {
  switch (variant) {
    case 'success':
      return {
        color: theme.color.tint.onSuccess,
        backgroundColor: theme.color.surface.success,
        icon: theme.color.tint.success,
      };
    case 'danger':
      return {
        color: theme.color.tint.onError,
        backgroundColor: theme.color.surface.error,
        icon: theme.color.solid.error,
      };
    case 'default':
      return {
        color: theme.color.tint.primary,
        backgroundColor: theme.color.surface.secondary,
        icon: theme.color.tint.tertiary,
      };
    case 'warning':
      return {
        color: theme.color.tint.onWarning,
        backgroundColor: theme.color.surface.warning,
        icon: theme.color.tint.warning,
      };
    case 'info':
      return {
        color: theme.color.tint.onInfo,
        backgroundColor: theme.color.surface.info,
        icon: theme.color.tint.onInfo,
      };
    case 'accent':
      return {
        color: theme.color.accent[90],
        backgroundColor: theme.color.accent[60],
        icon: theme.color.accent[90],
      };
    default:
      return {
        color: theme.color[variant][90],
        backgroundColor: theme.color[variant][50],
        icon: theme.color[variant][90],
      };
  }
}

export const TagSC = styled.span<{ colors: ReturnType<typeof getTagColor> }>`
  display: inline-flex;
  align-items: center;

  border-radius: ${({ theme }) => theme.radius.medium}px;

  &.${prefixCls}-small {
    ${({ theme }) => theme.mappedTypography.captionSmall.default};
    min-height: ${TAG_SIZE_MAP.small}px;
  }

  &.${prefixCls}-medium {
    ${({ theme }) => theme.mappedTypography.captionLarge.default};
    min-height: ${TAG_SIZE_MAP.medium}px;
  }

  &.${prefixCls}-large {
    ${({ theme }) => theme.mappedTypography.body2.strong};
    min-height: ${TAG_SIZE_MAP.large}px;
  }

  ${({ colors }) => css`
    color: ${colors.color};
    background-color: ${colors.backgroundColor};
  `};

  .${tagClasses.label} {
    width: 100%;
    white-space: nowrap;

    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
  }

  &.${`${tagClasses.component}-has-icon`} {
    .${tagClasses.label} {
      padding-left: 2px;
    }
  }
`;
